/* vs-collection.js — Vachansutra collection page behaviour (no Liquid). */
let Events = null;
try { Events = await import('@shopify/events'); } catch (e) { Events = null; }

function money(cents, fmt) {
  const n = cents / 100;
  const s = n.toLocaleString('en-IN', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  return String(fmt || '₹{{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, s).replace(/<[^>]+>/g, '');
}

function init(root) {
  if (!root || root.dataset.vscReady === '1') return;
  root.dataset.vscReady = '1';

  let cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-vsc-config]')?.textContent || '{}'); } catch (e) {}

  const grid = root.querySelector('[data-grid]');
  if (!grid) return;
  const cards = [...grid.querySelectorAll('.vsc-card')];
  const promo = grid.querySelector('[data-promo]');
  const moreBtn = root.querySelector('[data-more]');
  const shown = root.querySelector('[data-shown]');
  const bar = root.querySelector('[data-bar]');
  const countEl = root.querySelector('[data-count]');
  const matchEl = root.querySelector('[data-match]');
  const perPage = Number(cfg.perPage) || 16;
  let limit = perPage;
  let chip = 'all';
  let sort = 'featured';

  /* ---------- Meta ad matching ---------- */
  const isMeta = root.dataset.mode === 'meta';
  let ad = null;
  if (isMeta) {
    const key = (root.dataset.ad || '').toLowerCase();
    ad = (cfg.ads || []).find((a) => a.key && key && (key === a.key || key.includes(a.key))) || null;
    const d = cfg.defaultAd || {};
    const set = (sel, val) => { const el = root.querySelector(sel); if (el && val) el.textContent = val; };
    set('[data-ad-eyebrow]', (ad && ad.eyebrow) || d.eyebrow);
    set('[data-ad-offer]', (ad && ad.offer) || d.offer);
    set('[data-ad-lede]', (ad && ad.lede) || d.lede);
  }
  let adTag = ad && ad.tag ? ad.tag : null;

  /* ---------- render ---------- */
  function render() {
    let list = cards.slice();
    if (sort === 'newest') list.sort((a, b) => Number(b.dataset.created) - Number(a.dataset.created));
    else list.sort((a, b) => Number(a.dataset.i) - Number(b.dataset.i));

    const has = (c, t) => (' ' + c.dataset.tags + ' ').includes(' ' + t + ' ');
    let visible = chip === 'all' ? list : list.filter((c) => has(c, chip));
    const hiddenOnes = chip === 'all' ? [] : list.filter((c) => !has(c, chip));

    grid.querySelectorAll('.vsc-divider').forEach((d) => d.remove());
    let ordered = visible;
    let divideAt = -1;
    if (adTag && chip === 'all') {
      const m = visible.filter((c) => has(c, adTag));
      const r = visible.filter((c) => !has(c, adTag));
      if (m.length && r.length) { ordered = m.concat(r); divideAt = m.length; }
    }

    ordered.forEach((c, i) => {
      if (i === divideAt) {
        const d = document.createElement('li');
        d.className = 'vsc-divider';
        d.textContent = "More you'll love";
        grid.appendChild(d);
      }
      grid.appendChild(c);
      c.classList.toggle('is-hidden', i >= limit);
      if (promo && i === 5) grid.appendChild(promo);
    });
    hiddenOnes.forEach((c) => { grid.appendChild(c); c.classList.add('is-hidden'); });
    if (promo) promo.hidden = chip !== 'all' || ordered.length < 9;

    const total = ordered.length;
    const n = Math.min(limit, total);
    if (shown) shown.textContent = `Showing ${n} of ${total} designs`;
    if (bar) bar.style.width = total ? `${(n / total) * 100}%` : '0';
    if (moreBtn) moreBtn.hidden = n >= total;
    if (countEl) countEl.textContent = `${total} designs`;
    root.querySelectorAll('[data-chip]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.chip === chip)));

    if (matchEl) {
      if (adTag && chip === 'all' && divideAt > 0 && ad && ad.label) {
        matchEl.hidden = false;
        matchEl.innerHTML = `Showing <b></b> first <button type="button" data-see-all>See all designs</button>`;
        matchEl.querySelector('b').textContent = ad.label;
      } else matchEl.hidden = true;
    }
  }

  root.addEventListener('click', (e) => {
    const c = e.target.closest('[data-chip]');
    if (c) { chip = c.dataset.chip; limit = perPage; render(); return; }
    if (e.target.closest('[data-see-all]')) { adTag = null; render(); return; }
    if (e.target.closest('[data-more]')) { limit += perPage; render(); return; }
    const rm = e.target.closest('[data-readmore]');
    if (rm) { root.querySelector('[data-clamp]')?.classList.remove('is-clamped'); rm.hidden = true; return; }
    const add = e.target.closest('[data-add]');
    if (add) { addToBag(add); }
  });
  root.querySelector('[data-sort]')?.addEventListener('change', (e) => { sort = e.target.value; render(); });

  /* ---------- guide clamp (ad view only) ---------- */
  const clamp = root.querySelector('[data-clamp]');
  const rmBtn = root.querySelector('[data-readmore]');
  if (clamp && rmBtn) {
    if (isMeta) clamp.classList.add('is-clamped'); else rmBtn.hidden = true;
  }

  /* ---------- bag bar ---------- */
  const bogo = root.querySelector('[data-bogo]');
  const bogoMsg = root.querySelector('[data-bogo-msg]');
  const bogoBtn = root.querySelector('[data-bogo-btn]');
  function paintBar(count, total) {
    if (!bogo || !bogoMsg) return;
    bogo.classList.toggle('show', count > 0);
    if (count <= 0) return;
    if (count % 2 === 1) {
      bogoMsg.innerHTML = cfg.msgOdd || '';
      if (bogoBtn) bogoBtn.textContent = 'View bag';
    } else {
      bogoMsg.innerHTML = String(cfg.msgEven || '').replace('[count]', count).replace('[total]', money(total, cfg.money));
      if (bogoBtn) bogoBtn.textContent = 'Checkout';
      if (bogoBtn) bogoBtn.setAttribute('href', '/checkout');
    }
  }
  paintBar(Number(cfg.cartCount) || 0, Number(cfg.cartTotal) || 0);

  async function addToBag(btn) {
    const id = btn.dataset.add;
    const label = cfg.addText || 'Add to Bag';
    btn.classList.add('is-loading');
    const fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', '1');
    const sectionIds = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
    if (sectionIds.length) fd.append('sections', sectionIds.join(','));
    fd.append('sections_url', window.location.pathname);

    let deferred = null;
    try {
      if (Events && Events.CartLinesUpdateEvent) {
        deferred = Events.CartLinesUpdateEvent.createPromise();
        btn.dispatchEvent(new Events.CartLinesUpdateEvent({
          action: 'add', context: 'product',
          lines: [{ merchandiseId: id, quantity: 1 }],
          promise: deferred.promise,
        }));
      }
    } catch (e) { deferred = null; }

    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await res.json();
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      if (data.status) throw new Error(data.description || data.message || 'Could not add');
      try {
        if (deferred) deferred.resolve({
          cart: Events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'vs-collection', sourceId: root.id, itemCount: 1, sections: data.sections, didError: false },
        });
      } catch (e) {}
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      btn.textContent = 'Added ✓';
      setTimeout(() => { btn.classList.remove('is-added'); btn.textContent = label; }, 1600);
      paintBar(cart.item_count, cart.total_price);
    } catch (err) {
      try { if (deferred) deferred.reject(err); } catch (e) {}
      btn.classList.remove('is-loading');
      btn.textContent = 'Try again';
      setTimeout(() => { btn.textContent = label; }, 2000);
    }
  }

  render();
}

const boot = () => document.querySelectorAll('.vsc').forEach(init);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', (e) => {
  const el = e.target.querySelector('.vsc');
  if (el) { el.dataset.vscReady = ''; init(el); }
});
